<div class="back-button-block">
  <button mat-button (click)="backButton()">
    <i class="pi pi-angle-left"></i>
  </button>

  <div class="search-block">
    <input #searchInput pInputText BlockLateralArrowNavigation class="search-input" autocomplete="off"
           placeholder="Search" type="text"
           name="searchQuery" (keyup)="searchMethod(searchInput.value)"></div>
</div>


<div #projectsScroll class="users-block" *ngIf="!projectsIsLoading">
  <div class="user-block" *ngFor="let project of projects" matRipple [matRippleCentered]="false"
       (click)="chooseProject(project)">
    <div class="name-block">
      <i class="pi pi-clock" style="margin-right: 0.3em;" *ngIf="project.fromTimesheet"></i>{{project.name}}
    </div>
  </div>
  <div class="no-user-block" *ngIf="projects?.length < 1">
    Projects not found
  </div>
</div>

<div class="search-loading-screen" *ngIf="projectsIsLoading">
  <lib-progress-spinner></lib-progress-spinner>
</div>
